<main class="flex-column">
  <ng-content select="app-apt-toolbar"></ng-content>
  <div [hidden]="(toolbarPageLayoutService.showFilters$ | async) === false">
    <ng-content select="app-toolbar-filter-section,.fill-toolbar-filter-section"></ng-content>
  </div>
  
  <ng-content select="app-toolbar-breadcrumb-section"></ng-content>
  <div [hidden]="(toolbarPageLayoutService.showPageHeader$ | async) === false">
    <ng-content select="app-toolbar-header-section"></ng-content>
  </div>
  <div class="flex-column mt-2 height-auto">
    <div class="d-flex h-100">
      <ng-container
        *ngIf="optionsPosition === 'top'; then optionsSection"
      ></ng-container>
      <div class="page-section flex-column">
        <div [hidden]="(toolbarPageLayoutService.showCharts$ | async) === false">
          <ng-content select="app-toolbar-charts-section"></ng-content>
        </div>
      </div>
    </div>
  </div>
    <div class="flex-column mt-2 overflow-auto">
      <div class="d-flex h-100">
        <ng-container *ngIf="optionsPosition === 'side'; then optionsSection"></ng-container>
      <div class="page-section flex-column">
        <ng-content select="app-toolbar-page-section"></ng-content>
      </div>
        </div>
      </div>  
</main>

<ng-template #optionsSection>
  <div
    class="options-section"
    data-test-selector="toolbar-options-section"
    [hidden]="(toolbarPageLayoutService.showOptions$ | async) === false"
  >
    <ng-content select="app-toolbar-options-section"></ng-content>
  </div>
</ng-template>
